export default "__VITE_ASSET__qDKpqtEU__"